<template>
  <el-container>
    <el-header class="table-header">
      <el-button class="btn" type="primary" size="small" @click="handleAdd()">{{$t('common.Add')}}</el-button>
    </el-header>
    <el-main class="table-main">
        <el-table
          :data="tableData" stripe
          border style="width: 100%">
          <el-table-column
            type="index"
            width="50%">
          </el-table-column>
          <el-table-column
            prop="id"
            :label="$t('base.info.system.SystemId')"
            width="100%">
          </el-table-column>
          <el-table-column
            prop="code"
            :label="$t('base.info.system.SystemCode')"
            width="100%">
          </el-table-column>
          <el-table-column
            :label="$t('base.info.system.SystemName')"
            prop="name">
          </el-table-column>
          <el-table-column
            prop="remark"
            :label="$t('common.Remark')"
            width="380%">
          </el-table-column>
          <el-table-column
            prop="status"
            :label="$t('base.info.system.Effective')"
            align="center"
            sortable
            width="150%">
            <template slot-scope="scope">
              <span v-if="scope.row.status===50">{{$t('common.Y')}}</span>
              <span v-if="scope.row.status===30">{{$t('common.N')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('common.Operate')" width="180%">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">{{$t('common.Modify')}}</el-button>
              <el-button v-if="scope.row.status===30" type="text" size="mini"
                         @click="handleRestore(scope.$index, scope.row)">{{$t('common.Recovery')}}
              </el-button>
              <el-button size="mini" v-if="scope.row.status===50" type="text"
                         @click="handleDisable(scope.$index, scope.row)">{{$t('common.Disable')}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="title" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
                   :before-close="handleClose" width="30%">
          <el-form ref="form" :rules="CommitForm" :model="form" label-width="80px" size="mini">
            <el-form-item :label="$t('base.info.system.SystemCode') " prop="code">
              <el-input v-model="form.code" v-if="title===$t('common.Add')"></el-input>
              <el-input v-model="form.code" :disabled="true" v-if="title===$t('common.Modify')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('base.info.system.SystemName')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.Remark') " prop="remark">
              <el-input v-model="form.remark" type="textarea"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.Status') " prop="status" v-if="title===$t('common.Add')">
              <el-radio :label="30" v-model="form.status">{{$t('common.Disable')}}</el-radio>
              <el-radio :label="50" v-model="form.status">{{$t('common.Normal')}}</el-radio>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" size="mini" @click="update(form)">{{$t('common.Ok')}}</el-button>
            <el-button size="mini" @click="cancel()">{{$t('common.Cancel')}}</el-button>
          </div>
        </el-dialog>
    </el-main>
    <el-footer class="table-footer">
      <table-page ref="systemListPage" :url="systemListUrl" :form="{}" @page-change="convert"></table-page>
    </el-footer>
  </el-container>
</template>
<script>
import TablePage from '@/components/TablePage'

export default {
  name: 'transfer',
  data () {
    return {
      systemListUrl: this.global.BASE_INFO + '/system/findAll',
      form: {
        code: '',
        name: '',
        remark: '',
        status: 30
      },
      CommitForm: {
        status: [{required: true, trigger: 'change', message: this.$t('base.info.system.StatusCanNotEmpty')}],
        name: [{required: true, trigger: 'blur', message: this.$t('base.info.system.SystemNameCanNotEmpty')}],
        code: [{required: true, trigger: 'blur', message: this.$t('base.info.system.SystemCodeCanNotEmpty')}],
        remark: [{max: 90, message: this.$t('common.NotEmpty')}]
      },
      // 新增or编辑弹框标题(根据点击的新增or编辑按钮显示不同的标题)
      title: '',
      // 新增和编辑弹框标题
      dialogStatus: '',
      // 是否弹出对话框
      dialogFormVisible: false,
      tableData: []
    }
  },
  components: {
    TablePage
  },
  methods: {
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.form.id = row.id
      this.form.name = row.name
      this.form.code = row.code
      this.form.remark = row.remark
      this.form.status = row.status
      this.title = this.$t('common.Modify')
    },
    handleAdd () {
      this.dialogFormVisible = true
      this.title = this.$t('common.Add')
    },
    handleClose (done) {
      this.cancel()
    },
    handleDisable (index, row) {
      let param = {
        data: {id: row.id, status: 30}
      }
      this.$confirm(this.$t('common.Disable'), this.$t('common.Tips'), {
        confirmButtonText: this.$t('common.Ok'),
        cancelButtonText: this.$t('common.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.systemList.systemStatusUpdate(param).then((response) => {
          this.$refs['systemListPage'].getTableData()
          if (response.data.status === 'Y') {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'success'
            })
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error'
            })
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common.Cancel')
        })
      })
    },
    handleRestore (index, row) {
      let param = {
        data: {id: row.id, status: 50}
      }
      this.$confirm(this.$t('common.Recovery'), this.$t('common.Tips'), {
        confirmButtonText: this.$t('common.Ok'),
        cancelButtonText: this.$t('common.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.systemList.systemStatusUpdate(param).then((response) => {
          this.$refs['systemListPage'].getTableData()
          if (response.data.status === 'Y') {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'success'
            })
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error'
            })
          }
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    update (form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let param = {
            data: {id: form.id, name: form.name, remark: form.remark}
          }
          let that = this
          that.dialogFormVisible = false
          if (this.title === this.$t('common.Modify')) {
            this.$api.systemList.systemUpdate(param).then((response) => {
              this.$refs['systemListPage'].getTableData()
              this.cancel()
              if (response.data.status === 'Y') {
                this.$message({
                  showClose: true,
                  message: response.data.message,
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: response.data.message,
                  type: 'error'
                })
              }
            })
          }
          if (this.title === this.$t('common.Add')) {
            let param = {
              data: {code: form.code, name: form.name, remark: form.remark, status: form.status}
            }
            this.$api.systemList.systemInsert(param).then((response) => {
              this.$refs['systemListPage'].getTableData()
              this.form = {
                code: '',
                name: '',
                asp: '',
                remark: '',
                status: ''
              }
              if (response.data.status === 'Y') {
                this.$message({
                  showClose: true,
                  message: response.data.message,
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: response.data.message,
                  type: 'error'
                })
              }
              this.cancel()
            }).catch((error) => {
              console.log(error)
            })
          }
        }
      })
    },
    cancel () {
      this.dialogFormVisible = false
      this.form = {
        code: '',
        name: '',
        asp: '',
        remark: '',
        status: 30
      }
      this.$refs['form'].resetFields()
    },
    convert (table) {
      this.tableData = table.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/system/systemList.vue